import { mergeClassnames } from '@porterin/component-library/src/utils/mergeClassnames';
import React, { forwardRef } from 'react';

type inputInteractions = {
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
};

type inputOptions = {
  disabled?: boolean;
  placeholder?: string;
};

type identifiers = {
  id: string;
};

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  identifiers: identifiers;
  interactions?: inputInteractions;
  inputOptions?: inputOptions;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    { identifiers, interactions, inputOptions, className = '', ...props },
    ref,
  ) => {
    return (
      <input
        id={identifiers.id}
        ref={ref}
        disabled={inputOptions?.disabled ?? false}
        className={mergeClassnames(
          `flex items-center w-full rounded-md
              border
              px-6 py-5
              text-2xl text-black font-normal placeholder:text-muted-foreground 
              focus:outline-none
              disabled:cursor-not-allowed disabled:opacity-50`,
          className,
        )}
        onChange={interactions?.onChange}
        onBlur={interactions?.onBlur}
        onFocus={interactions?.onFocus}
        placeholder={inputOptions?.placeholder ?? ''}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export default Input;
